import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import Alert from "../../../components/alert/Alert";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import ReactHtmlParser from "react-html-parser";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getContractPoposal } from "../../../redux/actions/contractActions";

import DatePicker from "react-datepicker";
import moment from "moment";
import {aclUtil} from "../../util"

import "react-datepicker/dist/react-datepicker.css";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getContractPoposal: PropTypes.func.isRequired
};

let isLoading = "false";
class ContractDetails extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const viewLink = (props.match && props.match.params) && `contractDetails/${props.match.params.contractId}`
    super(props);
    this.state = {
      menuKey: 'VIEW_CONTRACT',
      path: ["Home", "Manage Contract", "Contract Details"],
      links:["home", "contractList", viewLink],
      contractDetails: '',
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handlePageChange = page => {
    let contractIdParams = this.props.match.params.contractId
      ? this.props.match.params.contractId
      : "";
    if (contractIdParams !== "") {
      isLoading = "true";
      this.props.getContractPoposal(contractIdParams);
    }
  };

  componentWillMount() {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    this.handlePageChange(1);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.contractDetails !== nextProps.contractDetails){
      if(nextProps.contractDetails){
        this.setState({contractDetails: nextProps.contractDetails.data});
        isLoading = "false";
      }
    }else{
      if(nextProps.contractDetails){
        this.setState({contractDetails: nextProps.contractDetails.data});
        isLoading = "false";
      }
    }
  }

  handleClick = (event) => {
    if (event.target.id =="agreeTermCondition1" && event.target.checked) {
      document.getElementById("agreeTermCondition").checked = false;
      document.getElementById("agreeTermCondition").removeAttribute("checked")
      document.getElementById("agreeTermCondition1").setAttribute("checked","true")
    }else if (event.target.id =="agreeTermCondition" && event.target.checked){
      document.getElementById("agreeTermCondition1").checked = false;
      document.getElementById("agreeTermCondition1").removeAttribute("checked")
      document.getElementById("agreeTermCondition").setAttribute("checked","true")
    }
  }

   printDiv = () => {
    let divToPrint = document.getElementById("DivIdToPrint");

    let newWin = window.open("", "Print-Window");

    newWin.document.open();

    newWin.document.write(
      '<html><body onload="window.print()">' +
        divToPrint.innerHTML +
        "</body></html>"
    );

    newWin.document.close();
  };

  render() {
    let contract =
      this.state.contractDetails
        ? this.state.contractDetails
        : {};
    return (
      <div className="col-lg-12 detail-Page">
      {isLoading == "true" ? (
        <div className="loader">
          <p className="loading-message">
            <i>Loading...</i>
          </p>
          <div className="spinner">
            <div className="dot1" />
            <div className="dot2" />
          </div>
        </div>
      ) : (
        ""
      )}
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 text-right">
            <Button
              bsSize="small"
              bsStyle="success"
              onClick={() => this.context.router.history.push("/contractList")}
            >
              Back To Contract List
            </Button>
          </div>
        </div>
        {/**start contract information **/}
        <div className="panel">
          <header className="panel-heading">
            Contract Detail
            <Button
            bsSize="small"
            className="pull-right"
            style={{backgroundColor: '#0656a7' }}
            data-id = 'printContract'
            bsStyle="success"
            type="submit"
            onClick={this.printDiv.bind(this)}
            >
            <i className="glyphicon glyphicon-print" /> Print Contract
            </Button>   
          </header>

          <div className="panel-body" id="DivIdToPrint" onClick={this.handleClick}>
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={12} xs={12}>
                {contract ? ReactHtmlParser(contract) : ''}
                </Col>
              </Row>
            </div>
          </div>
        </div>
        {/**end contract information **/}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    contractDetails: state.contractReducer.contractDetail
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { getContractPoposal })
)(ContractDetails);



// WEBPACK FOOTER //
// ./src/app/views/admin/contract/ContractDetails.js